import { formatFullName } from 'platform/shared/health-apps';
import { formatDateLong } from 'platform/utilities/date';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import content from '../../locales/en/content.json';

const ConfirmationPrintView = ({ name, timestamp }) => {
  const veteranFullName = useMemo(() => formatFullName(name), [name]);
  const submissionDate = useMemo(
    () => (timestamp ? formatDateLong(timestamp) : null),
    [timestamp],
  );

  return (
    <>
      <img
        src="/img/design/logo/logo-black-and-white.png"
        className="vads-u-max-width--100 vads-u-margin-bottom--4"
        width="300"
        alt=""
      />

      <h1 className="vads-u-font-size--h2 vads-u-margin-bottom--0">
        {content['app-title']}
      </h1>
      <div>{content['app-subtitle']}</div>

      <h2 className="vads-u-font-size--h3">
        {content['confirmation--alert-heading']}
      </h2>
      <p className="vads-u-margin-bottom--0">
        {content['confirmation--alert-text']}
      </p>

      <hr className="vads-u-margin-y--4" />

      <h2 className="vads-u-font-size--h3 vads-u-margin-top--0">
        {content['confirmation--info-heading']}
      </h2>
      <dl className="vads-u-margin-bottom--0">
        <div className="vads-u-margin-bottom--2">
          <dt className="vads-u-font-weight--bold">
            {content['confirmation--info-vet-label']}
          </dt>
          <dd data-testid="cg-veteranfullname" className="dd-privacy-mask">
            {veteranFullName}
          </dd>
        </div>
        {submissionDate && (
          <div>
            <dt className="vads-u-font-weight--bold">
              {content['confirmation--info-timestamp-label']}
            </dt>
            <dd data-testid="cg-timestamp">{submissionDate}</dd>
          </div>
        )}
      </dl>

      <hr className="vads-u-margin-top--4 vads-u-margin-bottom--0" />
    </>
  );
};

ConfirmationPrintView.propTypes = {
  name: PropTypes.shape({
    first: PropTypes.string,
    middle: PropTypes.string,
    last: PropTypes.string,
    suffix: PropTypes.string,
  }),
  timestamp: PropTypes.number,
};

export default ConfirmationPrintView;
